module.exports = __webpack_public_path__ + "static/img/icon_dui.5d488999.svg";